import { create } from 'zustand';

interface InsightsKpiStore {
  uniqueKpiId: string | undefined;
  setUniqueKpiId: (uniqueKpiId: string | undefined) => void;
}

export const useInsightsKpiStore = create<InsightsKpiStore>((set) => ({
  uniqueKpiId: undefined,
  setUniqueKpiId: (uniqueKpiId) => set({ uniqueKpiId }),
}));
